import { FadeUp } from "@/components/Reveal";
import { PARTNERS } from "@/data/content";

const LogoItem = ({ p }) => {
  const img = (
    <img
      src={p.logo}
      alt={p.name}
      className="h-14 md:h-20 w-auto object-contain rounded-lg select-none pointer-events-none"
      draggable={false}
    />
  );
  return p.url ? (
    <a
      href={p.url}
      target="_blank"
      rel="noopener noreferrer"
      title={p.name}
      data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
      className="shrink-0 mx-8 md:mx-12 opacity-85 hover:opacity-100 transition-opacity duration-300"
    >
      {img}
    </a>
  ) : (
    <span
      title={p.name}
      data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
      className="shrink-0 mx-8 md:mx-12 opacity-85"
    >
      {img}
    </span>
  );
};

export default function PartnerStrip() {
  const { kicker, title, items } = PARTNERS;
  if (!items || items.length === 0) return null;
  const loop = [...items, ...items];

  return (
    <section className="relative bg-white border-t border-ink/10 py-16 md:py-20 overflow-hidden" data-testid="partner-strip">
      <div className="px-5 md:px-10 text-center mb-12">
        <FadeUp>
          <p className="font-display text-xs uppercase tracking-[0.25em] text-magenta mb-4">{kicker}</p>
        </FadeUp>
        <FadeUp delay={0.05}>
          <h2 className="font-serif font-light text-3xl md:text-4xl text-ink max-w-2xl mx-auto leading-snug">{title}</h2>
        </FadeUp>
      </div>

      <div className="group relative w-full overflow-hidden">
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="flex w-max items-center animate-marquee-slow group-hover:[animation-play-state:paused]" data-testid="partner-marquee">
          {loop.map((p, i) => (
            <LogoItem key={`${p.name}-${i}`} p={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
